import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { isBlocked } from '../services/clinic-plan.rules';
import { ClinicPlanService } from '../services/clinic-plan.service';

/** Pages a locked branch can still open: the notice itself and the personal feeds. */
const ALWAYS_OPEN = ['/no-permission', '/notifications'];

/**
 * When the platform has switched clinic-app enforcement on and this branch's
 * plan has lapsed (past its grace days, or cancelled): staff and doctors go to
 * /plan-expired; owners keep Settings › Subscriptions to sort it out. Nothing is
 * deleted — renewing the plan reopens the app on the next check.
 */
export const planGuard: CanActivateChildFn = (_route, state) => {
  const plans = inject(ClinicPlanService);
  const router = inject(Router);

  return plans.whenReady().pipe(
    map((plan) => {
      if (!isBlocked(plan)) return true;
      const url = state.url;
      if (ALWAYS_OPEN.some((p) => url.startsWith(p))) return true;
      if (plan!.is_owner) {
        return url.startsWith('/settings') ? true : router.createUrlTree(['/settings'], { queryParams: { tab: 'subscriptions' } });
      }
      return router.createUrlTree(['/plan-expired']);
    }),
  );
};
